import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useCustomerRevealApiConfigPatch } from 'features/customers/hooks/useCustomerRevealApiConfigPatch'
import { REVEAL_API_LIMIT_LABELS } from 'features/customers/utils/features'

import { FormTextField } from 'components/input'
import { DescriptionListTable } from 'components/table'
import { withForm } from 'decorators/withForm'
import { parseDomainAllowlistInput } from 'validators/domain-allowlist'
import { modifyRevealApiLimitsValidator } from 'validators/reveal-api'

import RevealApiLimitField from './RevealApiLimitField'

const config = [
  {
    title: REVEAL_API_LIMIT_LABELS.revealApiRequestsLimit,
    render: () => <RevealApiLimitField name="revealApiRequestsLimit" />,
  },
  {
    title: REVEAL_API_LIMIT_LABELS.revealApiIdentifiedLimit,
    render: () => <RevealApiLimitField name="revealApiIdentifiedLimit" />,
  },
  {
    title: REVEAL_API_LIMIT_LABELS.revealApiUniqueIdentifiedIpsLimit,
    render: () => <RevealApiLimitField name="revealApiUniqueIdentifiedIpsLimit" />,
  },
  {
    title: 'Domain Allowlist',
    render: () => (
      <FormTextField
        helperText="Comma-separated list of allowed domains, e.g. example.com, app.example.com"
        name="publicApiKeyDomainAllowlist"
        placeholder="example.com, app.example.com"
      />
    ),
  },
]

type RevealApiLimitsModalProps = {
  handleSubmit: (...args: any[]) => any
  onClose: (...args: any[]) => any
}

const RevealApiLimitsModal = ({ handleSubmit, onClose }: RevealApiLimitsModalProps) => {
  const { patchRevealApiConfig } = useCustomerRevealApiConfigPatch()

  const onSubmit = async values => {
    const publicApiKeyDomainAllowlist = parseDomainAllowlistInput(values.publicApiKeyDomainAllowlist)
    await patchRevealApiConfig({
      requestQuota: Number.parseInt(values.revealApiRequestsLimit, 10),
      identifiedQuota: Number.parseInt(values.revealApiIdentifiedLimit, 10),
      uniqueIdentifiedIpsQuota: Number.parseInt(values.revealApiUniqueIdentifiedIpsLimit, 10),
      publicApiKeyDomainAllowlist,
    })
    onClose()
  }

  return (
    <Dialog onClose={onClose} open>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Manage Reveal API limits</DialogTitle>
        <DialogContent style={{ width: 500 }}>
          <DescriptionListTable config={config} titleCellStyle={{ width: 200 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="primary" type="submit">
            Update
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default withForm({ form: 'revealApiLimitsModify', validate: modifyRevealApiLimitsValidator })(
  RevealApiLimitsModal,
)
